

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";


import HeaderLight from "../../../../common/header/HeaderOne";
import FooterOne from "../../../../common/footer/FooterOne";

const products = () => {
  return (
    <>


<div className="blog-suggestions mt-5">
<h1 className="text-center mb-2 fw-500">You may be interested in</h1>

<div className="row">
  <div className="col-xxl-4">
    <div className="item-box-interest">
      <h4 className="" style={{FontSize: '18px' , fontWeight: '500', lineHeight: '1.2'}}>
        <a href="">
          Optimizing Customer Service with AI-powered Solutions
        </a>
      </h4>
      <h6 className="author mt-3 mb-2">Prakash Natraj</h6>

      <p>
        Elevate your Customer Service with AI Optimizing Customer
        Service with AI-powered Solutions Imagine a world where
        customer service is faster, more efficient, and available
        24/7. That's the promise of AI-powered…
      </p>

      <div class="btn-wraper mt-3">
        <a
          href="https://capdigisoft.com/blog/optimizing-customer-service-with-ai-powered-solutions/"
          class="elementskit-btn  whitespace--normal"
        >
          Learn more{" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
  <div className="col-xxl-4">
    <div className="item-box-interest">
      <h4 className="" style={{FontSize: '18px' , fontWeight: '500', lineHeight: '1.2'}}>
        <a href="">
          Optimizing Customer Service with AI-powered Solutions
        </a>
      </h4>
      <h6 className="author mt-3 mb-2">Prakash Natraj</h6>

      <p>
        Elevate your Customer Service with AI Optimizing Customer
        Service with AI-powered Solutions Imagine a world where
        customer service is faster, more efficient, and available
        24/7. That's the promise of AI-powered…
      </p>

      <div class="btn-wraper mt-3">
        <a
          href="https://capdigisoft.com/blog/optimizing-customer-service-with-ai-powered-solutions/"
          class="elementskit-btn  whitespace--normal"
        >
          Learn more{" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
  <div className="col-xxl-4">
    <div className="item-box-interest">
      <h4 className="" style={{FontSize: '18px' , fontWeight: '500', lineHeight: '1.2'}}>
        <a href="">
          Optimizing Customer Service with AI-powered Solutions
        </a>
      </h4>
      <h6 className="author mt-3 mb-2">Prakash Natraj</h6>

      <p>
        Elevate your Customer Service with AI Optimizing Customer
        Service with AI-powered Solutions Imagine a world where
        customer service is faster, more efficient, and available
        24/7. That's the promise of AI-powered…
      </p>

      <div class="btn-wraper mt-3">
        <a
          href="https://capdigisoft.com/blog/optimizing-customer-service-with-ai-powered-solutions/"
          class="elementskit-btn  whitespace--normal"
        >
          Learn more{" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</div>
</div>
    
    </>
       
     
  );
};

export default products;


